var listeners = {
  onRefreshTokenFailed: function onRefreshTokenFailed() {},
  onTokenChange: function onTokenChange() {},
  onAuthenticationError: function onAuthenticationError() {}
};

export default listeners;
//# sourceMappingURL=listeners.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/listeners.js
// module id = 305
// module chunks = 0